import React, { Component } from "react";
import getObj from "lodash/get";
import { connect } from "react-redux";
import { Form, Input, InputNumber, Card, Radio, Row, Col, Empty, Descriptions, DatePicker, Typography } from "antd";
import axios from "services/axios";
import moment from "moment";

const { Title } = Typography;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
    md: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
    md: { span: 16},
  },
};

const kelengkapanFormLayout = {
  labelCol: {
    xs: { span: 6 },
    sm: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 18 },
    sm: { span: 14 },
  },
};

const kelengkapan = [
  {
    label: "Kunci Cadangan",
    fieldName: "kunciCadangan",
  },
  {
    label: "Ban Cadangan",
    fieldName: "banCadangan",
  },
  {
    label: "BPKB",
    fieldName: "BPKB",
  },
  {
    label: "Faktur",
    fieldName: "faktur",
  },
  {
    label: "NIK/VIN",
    fieldName: "NIK/VIN",
  },
  {
    label: "Buku Servis",
    fieldName: "bukuServis",
  },
  {
    label: "Form A",
    fieldName: "formA",
  },
  {
    label: "Kwitansi Blanko",
    fieldName: "kwitansiBlanko",
  },
  {
    label: "STNK (PT)",
    fieldName: "STNK",
  },
  {
    label: "SPH (PT)",
    fieldName: "SPH",
  },
  {
    label: "NPWP (PT)",
    fieldName: "NPWP",
  },
  {
    label: "SIUP (PT)",
    fieldName: "SIUP",
  },
  {
    label: "Surat Kuasa Perpanjangan (PT)",
    fieldName: "SKPerpanjangan",
  },
  {
    label: "TDP (PT)",
    fieldName: "TDP",
  },
  {
    label: "Domisili (PT)",
    fieldName: "domisili",
  },
];

const options = [
  { label: "Available", value: "yes" },
  { label: "Not Available", value: "no" },
];

class OfferingDetail extends Component {
  state = {
    appraiserList: [],
  };

  componentDidMount = async () => {
    try {
      const {
        match: { params },
      } = this.props;

      let request = await axios.get(`/car-inquiry/${params.id}`);
      console.log(request)
      let res = await axios.get(`/handover/${request.data.inquiry.bookingId}`);
      console.log(res.data)
      await this.setState({
        ...request.data.inquiry,
        appraisal: request.data.appraisal,
        handover: res.data.handover || null,
        inquiry: request.data.inquiry,
        supervisor: request.data.supervisor
      });

    } catch (err) {
      console.log(err.message);
    }
  };

  kelengkapanValue (value) {
    if (value !== "Available") {
      value !== "yes" ? value = "no" : value
    } else {
      value= "yes"
    }
    return value
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { appraisal, Booking, handover, inquiry, supervisor} = this.state;
    return this.state.id ?(
      <Form layout="vertical">
      <Card>
        <Row gutter={16}>
          <Title level={3} style={inquiry.status === "DEAL" ? {color: "#52c41a"}: {color: "#f5222d"}}>
            Status: {inquiry.status}
          </Title>
          <Col xs={24} md={12}>
            <Descriptions size="small" title="Car Information" column={1} bordered={true}>
              {[
                "carDetail[7]",
                "carName",
                "carDetail[10]",
                "carDetail[11]",
                "year", 
                "carDetail[12]", 
                "carDetail[13]"
              ].map((field, index) => {
                return field === "carName" || field === "year"
                ? (
                  <Descriptions.Item key={index} label={field === "carName" ? "Mobil" : "Tahun"}>
                    {appraisal[field]}
                  </Descriptions.Item>
                )
                : (
                  <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                    {getObj(appraisal, field).value}
                  </Descriptions.Item>
                )})}
              <Descriptions.Item label={"Lokasi Penyimpanan"}>
                {inquiry.branchOffice}
              </Descriptions.Item>
            </Descriptions>

            <Descriptions size="small" title="Customer Information" column={1} bordered={true} style={{marginTop: 10}}>
              {["carDetail[0]", "carDetail[2]", "carDetail[1]"].map((field, index) => (
                <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                  {getObj(appraisal, field).value}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </Col>
          <Col xs={24} md={12}>
            <Descriptions size="small" title="Sales Informartion" column={1} bordered={true}>
              <Descriptions.Item label="Nama Sales">  {getObj(Booking, "SalesProfile.name")} </Descriptions.Item>
              <Descriptions.Item label="Nama Cabang"> {getObj(Booking, "SalesProfile.branch")} </Descriptions.Item>
              <Descriptions.Item label="No. Hp"> {getObj(Booking, "SalesProfile.phone")} </Descriptions.Item>
              <Descriptions.Item label="Nama SS"> {supervisor ? supervisor.name : ""} </Descriptions.Item>
            </Descriptions>

            <Descriptions size="small" title="Appraiser Informartion" column={1} bordered={true}>
              <Descriptions.Item label="Nama Appraiser">  {getObj(Booking, "Appraiser.name")} </Descriptions.Item>
              <Descriptions.Item label="No. Hp"> {getObj(Booking, "Appraiser.phone")} </Descriptions.Item>
            </Descriptions>

            <Descriptions size="small" title="TNT Informartion" column={1} bordered={true}>
              <Descriptions.Item label="Nama TNT">  {getObj(inquiry, "PriceNegotiator.name")} </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>

        <Row>
          <Card title="Negotiation Form" style={{ marginTop: "30px" }}>
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <FormItem label="Harga Nett" {...formItemLayout}>
                    {getFieldDecorator("priceNegotiation", {
                      initialValue: this.state.negotiationPrice,
                    })(
                      <InputNumber
                        disabled={true}
                        style={{ width: "100%" }}
                        formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      />,
                    )}
                  </FormItem>
                  <FormItem label="Harga Nego" {...formItemLayout}>
                    {getFieldDecorator("priceFromNegotiator", {
                      initialValue: this.state.priceFromNegotiator,
                    })(
                      <InputNumber
                        disabled={true}
                        style={{ width: "100%" }}
                        formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      />,
                    )}
                  </FormItem>
                  <FormItem label="Harga Final" {...formItemLayout}>
                    {getFieldDecorator("dealPrice", {
                      initialValue: this.state.dealPrice || 0,
                    })(
                      <InputNumber
                        style={{ width: "100%" }}
                        formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                        disabled={this.state.status !== "DEAL_CONFIRMATION"}
                      />,
                    )}
                  </FormItem>
                </Col>

                <Col xs={24} md={12}>
                  <FormItem label="Driver" {...formItemLayout}>
                  {getFieldDecorator("appraiser", {
                    initialValue: handover ? handover.Appraiser.name : "",
                  })(
                    <Input disabled/>
                    )}
                  </FormItem>

                  <FormItem label="Tanggal Pengambilan" {...formItemLayout}>
                    {getFieldDecorator("collectionDate", {
                      initialValue: this.state.collectionDate
                        ? moment(this.state.collectionDate, "YYYY-MM-DDTHH:mm")
                        : moment(),
                    })(<DatePicker style={{ width: "100%" }} disabled/>)}
                  </FormItem>

                  <FormItem label="Catatan Handover" {...formItemLayout}>
                    {getFieldDecorator("acquisitorNotes", {
                      initialValue: handover ? handover.acquisitorNotes : "",
                    })(<Input.TextArea rows={4} disabled/>)}
                  </FormItem>
                </Col>
              </Row>
          </Card>
        </Row>
      
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Card title="Kelengkapan" style={{marginTop: 30}}>
              {kelengkapan.map((item, index) => (
                <FormItem label={item.label} {...kelengkapanFormLayout} key={index}>
                  {getFieldDecorator(item.fieldName, {
                    rules: [{ require: true, message: "Kelengkapan Wajib Diisi" }],
                    initialValue: inquiry.misc ? this.kelengkapanValue(inquiry.misc[item.fieldName]) : "yes",
                  })(<RadioGroup options={options} disabled/>)}
                </FormItem>
              ))}
            </Card>
          </Col>

          <Col xs={24} md={12}>
            <Card title="Dokumen Handover" style={{marginTop: 30}}>
              {!handover ? null : handover.misc.map((item, index) => (
                <FormItem label={item.fieldname} {...kelengkapanFormLayout} key={index}>
                  {getFieldDecorator(item.fieldname, {
                    rules: [{ require: true, message: "Kelengkapan Dokumen Handover Wajib Diisi" }],
                    initialValue: item.value,
                  })(<RadioGroup options={options} disabled/>)}
                </FormItem>
              ))}
            </Card>
          </Col>
        </Row>

        <Row gutter={16}>
            <Card title="Handover Form" style={{ marginTop: "30px" }}>
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <FormItem label="Lokasi Handover" {...formItemLayout}>
                    {getFieldDecorator("location", {
                      initialValue: handover ? handover.location : "",
                    })(
                      <Input disabled/>,
                    )}
                  </FormItem>

                  <FormItem label="Catatan Supervisor" {...formItemLayout}>
                    {getFieldDecorator("acquistorNotes", {
                      initialValue: inquiry.acquisitorNotes
                    })(
                      <Input.TextArea disabled/>,
                    )}
                  </FormItem>

                  <FormItem label="Catatan Driver" {...formItemLayout}>
                    {getFieldDecorator("driverNotes", {
                      initialValue: handover ? handover.driverNotes : ""
                    })(<Input.TextArea disabled />)}
                  </FormItem>
                </Col>

                <Col xs={24} md={12}>
                  <FormItem label="Nomor Mesin" {...formItemLayout}>
                    {getFieldDecorator("nomorMesin", {
                      initialValue: appraisal.carDetail[8].value
                    })(<Input disabled />)}
                  </FormItem>

                  <FormItem label="Nomor Rangka" {...formItemLayout}>
                    {getFieldDecorator("nomorRangka", {
                      initialValue: appraisal.carDetail[9].value
                    })(<Input disabled />)}
                  </FormItem>
                  
                  <FormItem label="Catatan dari Document Admin" {...formItemLayout}>
                    {getFieldDecorator("documentAdminNotes", {
                      initialValue:  handover ? handover.DocumentAdminNotes : ""
                    })(<Input.TextArea disabled/>)}
                  </FormItem>

                  <FormItem label="Catatan dari Finance" {...formItemLayout}>
                    {getFieldDecorator("financeAdminNotes", {
                      initialValue: handover ? handover.FinanceAdminNotes : ""
                    })(<Input.TextArea disabled />)}
                  </FormItem>
                </Col>
              </Row>
            </Card>
          </Row>
      </Card>
      </Form>
    ) : (<Empty/>) ;
  }
}

const FormOffering = Form.create()(OfferingDetail);
const mapStateToProps = ({ Auth }) => ({ Auth });

export default connect(mapStateToProps)(FormOffering);



// WEBPACK FOOTER //
// src/components/Dashboard/InternalBidding/Final/FinalDetail.js